<template>
    <v-flex>    
        <v-flex>
            <v-flex xs12  md6 px-2 v-if="isNew">                                                                          
                <label>Wat voor event wil je registreren?</label>
                <v-flex xs12 style="min-height:100px;">                    
                    <v-radio-group v-model="eventFormType" :mandatory="true" :disabled="!isNew">
                    <v-radio label="Voorgedefinieerd" value="predefined"></v-radio>
                    <v-radio label="Zelf samensgesteld" value="custom"></v-radio>
                    </v-radio-group>                                        
                </v-flex>                 
            </v-flex>             
        </v-flex>
        <v-form
            v-if="eventFormType"
            ref="unitTypeEventForm"
            v-model="formValid"
            lazy-validation>                       
                <v-flex v-if="!isCustomEvent" xs12  px-2 pb-4>                                             
                    <v-select 
                        :disabled="!isNew"
                        item-text="text"                                 
                        :items="predefinedEventsDd"
                        label="Kies een event"
                        v-model="predefinedEventId"
                        :rules="[formRules.predefinedId]" 
                        required                
                    ></v-select>                                    
                </v-flex>
                <v-flex v-if="isCustomEvent">                
                    <v-layout row wrap>
                        <v-flex xs12 px-2 md6>                            
                            <v-text-field
                            v-model="selectedUnitTypeEvent.name"                     
                            label="Event naam"
                            :rules="[formRules.name]"                         
                            required>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 px-2>
                            <v-select 
                            item-text="text"                                 
                            :items="eventTypesDd"
                            :rules="[formRules.eventType]"   
                            label="Event soort"
                            v-model="selectedUnitTypeEvent.eventType.id"
                            required
                            ></v-select>                                                                
                        </v-flex>                                       
                    </v-layout>    
                        
                    <v-flex xs12 px-2 pt-2>                            
                        <v-textarea
                        v-model="selectedUnitTypeEvent.shortText"                     
                        label="Korte tekst event (gebruikt voor weergave)"
                        :rules="[formRules.shortText]"
                        required
                        outline>
                        </v-textarea>
                    </v-flex>      
                    <v-flex xs12 md6 px-2 v-if="withUnitTypeSelector">                            
                        <v-select 
                        item-value="id"
                        item-text="name"                                 
                        :items="unitTypes"
                        label="Unitsoort"
                        v-model="selectedUnitTypeEvent.unitTypeId"
                        required
                        ></v-select>    
                    </v-flex>          
                    <!-- not needed anymore
                    <v-flex xs12 md6 px-2>
                        <v-select 
                        item-text="text"                                 
                        :items="eventSeveritiesDd"
                        :rules="[formRules.severity]"   
                        label="Kriticiteit"
                        v-model="selectedUnitTypeEvent.eventSeverity.id"
                        required
                        ></v-select>                                                                
                    </v-flex>    
                    -->       
                                 
                    <v-flex x12 md6 px-2>                                
                        <v-switch 
                            label="Geautomatiseerd event"
                            v-model="selectedUnitTypeEvent.iotEvent">
                        </v-switch>                                
                    </v-flex>     
                    <v-layout row wrap>
                        <v-flex xs12 md4 px-2 v-if="isIotEvent">
                            <v-select                     
                            label="Data veld"
                            item-value="id"
                            item-text="customField.name"                                 
                            :items="dataFields"
                            :rules="[formRules.dataField]"                       
                            v-model="dataFieldMapperId"
                            required
                            ></v-select>                                                                
                        </v-flex> 
                        <v-flex xs12 md4 px-2 v-if="isIotEvent">
                            <v-select 
                            item-value="internal_name"
                            item-text="label"                                 
                            :items="operators"
                            :rules="[formRules.statusOperator]"   
                            label="Operator type"
                            v-model="statusOperator"
                            required
                            ></v-select>                                                                
                        </v-flex> 
                        <v-flex xs12 md4 px-2 v-if="isIotEvent">
                            <v-text-field
                            v-model="statusValue"                     
                            :label="`Afzet waarde ${dataFieldType}`"
                            :rules="[formRules.statusValue]"                         
                            required>
                            </v-text-field>                                                            
                        </v-flex>    
                    </v-layout>                        
                </v-flex>
                <!--
                <v-flex xs12 md6 px-2>                            
                    <v-text-field
                    v-if="selectedUnitTypeEvent.iotEvent"
                    v-model="selectedUnitTypeEvent.iotCode"                     
                    label="Event trigger naam">                                
                    </v-text-field>               
                </v-flex>                      
                <v-flex xs12 md12 px-2>                            
                    <v-text-field
                    v-model="selectedUnitTypeEvent.internalEventName"                     
                    label="Event functie aanroepnaam">
                    </v-text-field>               
                </v-flex>   
                -->       
                <v-layout row wrap align-center>         
                    <v-flex xs12 md6 px-2 >                                                                          
                        <label>Wanneer moet dit event registreren?</label>
                        <v-flex xs6 style="min-height:100px;">                            
                            <v-radio-group v-model="timeTableActive" :mandatory="true">
                            <v-radio label="Altijd" value="no"></v-radio>
                            <v-radio label="Tijdstabel" value="yes"></v-radio>
                            </v-radio-group>                                        
                        </v-flex>                 
                    </v-flex>       

                    <v-flex v-if="timeTableActive=='yes'" xs12 md6>
                        <v-flex px-2>                            
                            <v-select 
                            item-text="text"                                 
                            :items="timeTableZoneDd"
                            label="Kies binnen of buiten periode"
                            v-model="selectedUnitTypeEvent.timeTableZone"                
                            ></v-select>             
                        </v-flex>                   
                        <v-flex px-2>                            
                            <v-select 
                            item-text="text"                                 
                            :items="timeTablesDd"
                            label="Kies periode"
                            v-model="selectedUnitTypeEvent.timeTableId"                
                            ></v-select>             
                        </v-flex> 
                    </v-flex>  
                </v-layout> 
                <v-flex xs12>
                    <v-layout row wrap align-center>
                        <v-flex xs12 md6 px-2>                                                                          
                            <label>Hoe vaak moet dit event registreren?</label>
                            <v-flex xs6 style="min-height:100px;">
                                
                                <v-radio-group v-model="useTriggerAmount" :mandatory="true">
                                <v-radio label="Altijd" value="no"></v-radio>
                                <v-radio label="Met interval" value="yes"></v-radio>
                                </v-radio-group>                                        
                            </v-flex>                                   
                        </v-flex>       
                        <v-flex v-if="useTriggerAmount=='yes'" xs12 md6 px-2>
                            <v-text-field
                            v-model="triggerAmount"                     
                            label="Maximaal 1x per (aantal minuten)"
                            :rules="[formRules.name]"                         
                            required>
                            </v-text-field>                  
                        </v-flex>                          
                    </v-layout>                    
                </v-flex>
              
                <v-flex row xs12>                  
                    <v-layout wrap>
                        <v-btn
                            @click="cancel"                          
                            color=""> 
                            Annuleren
                        </v-btn>                                                                                                         
                        <v-spacer></v-spacer>                                         
                        <v-btn v-if="showProcedureButton"                                                
                            color="secondary"
                            @click="openWorkflow">
                            workflow configureren
                        </v-btn>                                  
                        <v-btn                                                
                            color="success"
                            @click="save">
                            Opslaan
                        </v-btn>                        
                    </v-layout>                                                                    
                </v-flex>                                      
        </v-form>   
    </v-flex> 
</template>
<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import Notification from "../../components/global/Notification"
    import _ from 'lodash';

    export default {
        data() {
            return {      
                eventFormType:null,
                predefinedEventId:null,
                useTriggerAmount:"no",
                triggerAmount:null,
                dataFieldMapperId:null,    
                statusOperator:null,
                statusValue:null,
                timeTableActive:"no",      
                formValid:true,                   
                formRules:{
                    name:(value) => {return (value) ? true : "Veld verplicht"},
                    eventType:(value) => {return (value) ? true : "Veld verplicht"},
                    shortText:(value) => {return (value) ? true : "Veld verplicht"},
                    dataField:(value) => {return (value) ? true : "Veld verplicht"},      
                    statusValue:(value) => {return (value) ? true : "Veld verplicht"},      
                    statusOperator:(value) => {return (value) ? true : "Veld verplicht"},   
                    predefinedId:(value) => {return (value) ? true : "Veld verplicht"},                         
                }, 
                selectedUnitTypeEvent:{id:"",name:"", iotEvent:true, unitTypeId:"" ,timeTableId:"",timeTableZone:"", eventType:{id:1}, eventSeverity:{id:1},triggerIntervalMinutes:null}          
            }
        },
        props:{ 
                withUnitTypeSelector:{
                   type:Boolean,
                   default:false                    
                },
                unitTypeId:{
                    type:String
                },            
                unitTypeEvent:{
                    type:Object                    
                },
                hideWorkFlowButton:{
                   type:Boolean,
                   default:false
                },
                parentActionId:{
                   default:0
                },
                parentActionRelationType:{
                   type:String,
                   default:"none",
                   validator:(value) => { // only allowed types are:
                       return ["none","cancel","done"].indexOf(value) !== -1 ? true : false
                   }
                }
        },
        computed: {
            ...mapGetters({
                unitTypes: types.UNIT_TYPES,
                eventTypes: types.EVENT_TYPES,
                // eventSeverities: types.EVENT_SEVERITIES,
                timeTables: types.TIME_TABLES,
                dataFields: types.UNIT_TYPE_DATA_FIELDS,        
                operators: types.HD_OPERATORS,    
                predefinedEvents: types.PREDEFINED_EVENTS,                             
            }),
            isNew(){
                return this.selectedUnitTypeEvent.id ? false : true
            },
            isCustomEvent(){
                return this.eventFormType == "custom" ? true : false
            },
            timeTableZoneDd(){
                return [{value:"inside",text:"Binnen"},{value:"outside",text:"Buiten"}]
            },
            timeTablesDd(){
                let ts =  this.timeTables.map((ele) => {                            
                    return {text: ele.name, value: ele.id}
                })
                return (ts !== null) ? ts : []                      
            },
            isIotEvent(){
                return (this.selectedUnitTypeEvent && this.selectedUnitTypeEvent.iotEvent) ? true : false
            },
            dataFieldType(){
                return ""
            },
            eventTypesDd(){
                let ts =  this.eventTypes.map((ele) => {                            
                    return {text: ele.name, value: ele.id}
                })
                return (ts !== null) ? ts : []                
            },
            predefinedEventsDd(){
                let ts =  this.predefinedEvents.map((ele) => {                            
                    return {text: ele.name, value: ele.id}
                })
                return (ts !== null) ? ts : []  
            },
            eventSeveritiesDd(){
                let ts =  this.eventSeverities.map((ele) => {                            
                    return {text: ele.name, value: ele.id}
                })                
                return (ts !== null) ? ts : []    
            },
            showProcedureButton(){
               return !this.hideWorkFlowButton && this.selectedUnitTypeEvent.id != "" ? true : false
            },
            selectedUnitType(){
                return this.unitTypes.find((ele) => {
                                    return ele.id == this.unitTypeId
                        })
            }     
        },   
        methods:{
            save(){
                if (this.$refs.unitTypeEventForm.validate()) {                    
                    let save    = {}
                        save.id = this.selectedUnitTypeEvent.id

                    if(!this.isCustomEvent){
                        // if it is a new predefined event prepare the object from chosen predefined
                        if(this.isNew){
                            save = this.preparePredefined()
                        }
                    }                
                    else{ // prepare custom event object
                        save.id                = this.selectedUnitTypeEvent.id
                        save.name              = this.selectedUnitTypeEvent.name
                        save.iotEvent          = this.selectedUnitTypeEvent.iotEvent ? true : false                                                
                        save.internalEventName = null // save.iotEvent ?  this.selectedUnitType.positionEvent : null
                        save.iotCode           = save.iotEvent ? this.selectedUnitType.positionEvent : null
                        save.shortText         = this.selectedUnitTypeEvent.shortText
                        save.eventTypeId       = this.selectedUnitTypeEvent.eventType.id
                        save.unitTypeId        = this.selectedUnitTypeEvent.unitTypeId
                        save.operator          = this.statusOperator
                        save.value             = this.statusValue
                        save.dataFieldMapperId = this.dataFieldMapperId                           
                    }
  
                    // add global parameters needed for both types
                    if(this.useTriggerAmount == "yes"){
                        save.triggerIntervalMinutes = this.triggerAmount
                    }
                    else{
                        save.triggerIntervalMinutes = 0
                    }                    
                    if(this.timeTableActive == "yes"){
                        save.timeTableId=this.selectedUnitTypeEvent.timeTableId
                        save.timeTableZone=this.selectedUnitTypeEvent.timeTableZone
                    }
                    else{
                        save.timeTableZone=""
                        save.timeTableId=""
                    }

                    // Default save (no relations required)
                    if(this.parentActionRelationType == "none"){
                        this.$store.dispatch(types.SAVE_UNIT_TYPE_EVENT, {data:save} ).then((e) => {                                                                   
                            this.selectedUnitTypeEvent.id = e.id                            
                            this.$emit('saved', this.selectedUnitTypeEvent)
                        }); 
                    }
                    // Save as cancel event on given action id
                    else if(this.parentActionRelationType == "done"){
                        save.parentUnitTypeEventActionId = this.parentActionId
                        this.$store.dispatch(types.SAVE_UNIT_TYPE_ACTION_DONE_EVENT, {data:save} ).then((e) => {          
                               this.selectedUnitTypeEvent.id = e.id                                                         
                               this.$emit('saved', this.selectedUnitTypeEvent)
                        }); 
                    }
                    // Save as done event on given action id                    
                    else if(this.parentActionRelationType == "cancel"){
                        save.parentUnitTypeEventActionId = this.parentActionId
                        this.$store.dispatch(types.SAVE_UNIT_TYPE_ACTION_CANCEL_EVENT, {data:save} ).then((e) => {       
                            this.selectedUnitTypeEvent.id = e.id
                            this.$emit('saved', this.selectedUnitTypeEvent)
                        }); 
                    }   
                
                }                       
            },   
            preparePredefined(){
                let pred = this.predefinedEvents.find((ele) => {
                                return ele.id == this.predefinedEventId
                           }) 
                let eventType = this.eventTypes.find((ele) => {
                                    return ele.internalName == pred.eventTypeInternalName
                                })
                let saveObj = {}

                saveObj.name              = pred.name
                saveObj.shortText         = pred.shortText                
                saveObj.iotEvent          = pred.iotEvent                
                saveObj.internalEventName = pred.internalEventName
                saveObj.iotCode           = pred.iotCode
                saveObj.unitTypeId        = this.selectedUnitType.id
                saveObj.eventTypeId       = eventType.id
                saveObj.operator          = pred.trigger && pred.trigger.operator ? pred.trigger.operator : ""
                saveObj.value             = pred.trigger && pred.trigger.value ? pred.trigger.value : ""
                // saveObj.iotCode           = pred.useUnitTypePositionEvent ? this.selectedUnitType.positionEvent : pred.useOtherEvent
                saveObj.predefinedEventId = this.predefinedEventId

                return saveObj
            },
            cancel(){
                this.$emit('cancelClicked')                    
            },     
            openWorkflow(){
                this.$emit('workflowClicked')   
            },                
            loadBaseUnitTypeEventData(){
                
                if(this.eventTypes.length==0){
                    this.$store.dispatch(types.EVENT_TYPES,{})
                }
                /* NOT NEEDED ANYMORE SO DISABLED FOR NOW
                if(this.eventSeverities.length==0){
                    this.$store.dispatch(types.EVENT_SEVERITIES,{})                              
                }
                */
               this.$store.dispatch(types.PREDEFINED_EVENTS,{ params:{selectable:true}})
                
                this.$store.dispatch(types.UNIT_TYPE_DATA_FIELDS, { data:{unit_type_id: this.selectedUnitTypeEvent.unitTypeId}, params: {include:"customField.type"} })     
            },
            loadForm(){
                if(this.unitTypeEvent){
                    Object.assign(this.selectedUnitTypeEvent, this.unitTypeEvent)                                
                }
                else if(this.unitTypeId){
                    this.selectedUnitTypeEvent.unitTypeId = this.unitTypeId
                }  
                
                if(this.selectedUnitTypeEvent.timeTableId){
                    this.timeTableActive="yes"
                }

                if(!this.isNew){
                    // check if item is custom or predefined
                    if(this.selectedUnitTypeEvent.predefinedEventId){
                        this.eventFormType = "predefined"
                        this.predefinedEventId = this.selectedUnitTypeEvent.predefinedEventId
                    }
                    else{
                        this.eventFormType     = "custom"
                        this.dataFieldMapperId = this.selectedUnitTypeEvent.dataFieldMapperId
                        this.statusOperator    = this.selectedUnitTypeEvent.trigger && this.selectedUnitTypeEvent.trigger.operator ? this.selectedUnitTypeEvent.trigger.operator : null
                        this.statusValue       = this.selectedUnitTypeEvent.trigger && this.selectedUnitTypeEvent.trigger.value ? this.selectedUnitTypeEvent.trigger.value : null 
                    }
                }
                
                if(this.selectedUnitTypeEvent.triggerIntervalMinutes){
                    this.useTriggerAmount = "yes"
                    this.triggerAmount = this.selectedUnitTypeEvent.triggerIntervalMinutes
                }

                if(this.withUnitTypeSelector){
                    this.$store.dispatch(types.UNIT_TYPES, { params: {} })
                }

                this.$store.dispatch(types.TIME_TABLES, { params: {} })

    
                this.loadBaseUnitTypeEventData()                
            }
        },
        mounted(){        
            this.loadForm()         
        }                    
    }
</script>

<style scoped>

</style>